module.exports = __webpack_public_path__ + "img/linkd2-2.76077b66.webp";